import React from "react";

import { MODIFIED_ORDER_SUMMARY_COLUMNS } from "constants/config";
import Table from "../../widgets/Table";
import { formatAddress } from "utils/formatAddress";
import SuccessIcon from "../Icons/SuccessIcon";

import styles from "./ModifiedOrderSummary.module.scss";

const formatCurrency = (value) =>
  typeof value === "number" ? `₹ ${value.toLocaleString()}` : "N/A";

const getProposedOrderSummaryRows = (proposal) => {
  const formatPackages = (packages) =>
    packages?.map((p) => p.name).join("\n") || "N/A";

  if (!proposal) return [];

  return [
    {
      description: "Course(s)",
      proposedOrder: formatPackages(proposal.packages),
    },
    {
      description: "Order Amount",
      proposedOrder: formatCurrency(proposal.amount),
    },
    {
      description: "Billing Name",
      proposedOrder: proposal.billing_address?.recipient_name,
    },
    {
      description: "Billing Address",
      proposedOrder: formatAddress(proposal.billing_address),
    },
    {
      description: "Shipping Name",
      proposedOrder: proposal.shipping_address?.recipient_name || "N/A", 
    },
    {
      description: "Shipping Address",
      proposedOrder: formatAddress(proposal.shipping_address),
    },
  ];
};

const ModifiedOrderSummary = ({ proposedOrder }) => {
  const rows = getProposedOrderSummaryRows(proposedOrder);

  return (
    <div className={styles.modifiedOrderSummaryMainContainer}>
      <div className={styles.card}>
        <div className={styles.statusIconWrapper}>
          <SuccessIcon />
        </div>
        <div className={styles.headerText}>
          <div className={styles.title}>Your order has been modified!</div>
          <div className={styles.subtitle}>
            The request to modify the order has been approved.
          </div>
        </div>
        <div className={styles.tableWrapper}>
          <Table columns={MODIFIED_ORDER_SUMMARY_COLUMNS} rows={rows} />
        </div>
        <div className={styles.disclaimerText}>
          You may reach out to our customer support team at{" "}
          <span className={styles.supportNumber}>1800-570-6262</span> for
          further assistance.
        </div>{" "}
      </div>
    </div>
  );
};

export default ModifiedOrderSummary;
